import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import Header from '@/components/Header'
import { getSummary } from '@/services/api'

export default function Dashboard() {
  const { user } = useAuth()
  const navigate = useNavigate()
  const [summary, setSummary] = useState({
    todaySuccessCount: 0,
    todayFailedCount: 0,
    todayTotalAmount: 0,
    processingCount: 0
  })
  

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await getSummary()
        const s = res.data?.summary ?? {}
        setSummary({
          todaySuccessCount: Number(s.todaySuccessCount ?? 0),
          todayFailedCount: Number(s.todayFailedCount ?? 0),
          todayTotalAmount: Number(s.todayTotalAmount ?? 0),
          processingCount: Number(s.processingCount ?? 0)
        })
      } catch (e) {
      }
    }
    fetch()
  }, [user?.activeMerchantId])

  const menuItems = [
    {
      title: '发起转账',
      description: '向用户微信账户发起转账',
      icon: '💸',
      path: '/transfer/create',
      color: 'bg-wechat-green hover:bg-wechat-dark'
    },
    {
      title: '转账历史',
      description: '查看所有转账记录',
      icon: '📋',
      path: '/transfer/history',
      color: 'bg-blue-500 hover:bg-blue-600'
    },
    {
      title: 'API设置',
      description: '配置微信支付API',
      icon: '⚙️',
      path: '/settings',
      color: 'bg-purple-500 hover:bg-purple-600'
    },
    {
      title: '绑定管理',
      description: '生成授权链接和管理授权用户',
      icon: '🔗',
      path: '/bindings',
      color: 'bg-teal-500 hover:bg-teal-600'
    },
    {
      title: '用户管理',
      description: '管理员管理平台用户',
      icon: '👤',
      path: '/users',
      color: 'bg-orange-500 hover:bg-orange-600',
      role: 'admin'
    },
    {
      title: '商户管理',
      description: '系统管理员管理所有商户',
      icon: '🏬',
      path: '/merchants',
      color: 'bg-indigo-500 hover:bg-indigo-600',
      role: 'system_admin'
    },
    {
      title: '个人信息',
      description: '编辑个人资料与密码',
      icon: '🙍',
      path: '/profile',
      color: 'bg-gray-600 hover:bg-gray-700'
    }
  ]

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />

      {/* Main Content */}
      <main className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div className="px-4 py-6 sm:px-0">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {menuItems.filter((i:any)=>!i.role || user?.role===i.role).map((item, index) => (
              <div
                key={index}
                onClick={() => navigate(item.path)}
                className="bg-white overflow-hidden shadow rounded-lg hover:shadow-lg transition-shadow cursor-pointer"
              >
                <div className="p-5">
                  <div className="flex items-center">
                    <div className={`flex-shrink-0 w-12 h-12 ${item.color} rounded-md flex items-center justify-center`}>
                      <span className="text-2xl">{item.icon}</span>
                    </div>
                    <div className="ml-5 w-0 flex-1">
                      <dl>
                        <dt className="text-sm font-medium text-gray-500 truncate">
                          {item.title}
                        </dt>
                        <dd className="text-lg font-medium text-gray-900">
                          {item.description}
                        </dd>
                      </dl>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 px-5 py-3">
                  <div className="text-sm">
                    <button className="font-medium text-wechat-green hover:text-wechat-dark">
                      立即使用 →
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Stats */}
          <div className="mt-8 grid grid-cols-1 md:grid-cols-4 gap-6">
            <div className="bg-white overflow-hidden shadow rounded-lg">
              <div className="p-5">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center">
                      <span className="text-white text-sm font-bold">✓</span>
                    </div>
                  </div>
                  <div className="ml-5 w-0 flex-1">
                    <dl>
                      <dt className="text-sm font-medium text-gray-500 truncate">
                        今日成功转账
                      </dt>
                      <dd className="text-lg font-medium text-gray-900">
                        {summary.todaySuccessCount}笔
                      </dd>
                    </dl>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white overflow-hidden shadow rounded-lg">
              <div className="p-5">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <div className="w-8 h-8 bg-red-500 rounded-full flex items-center justify-center">
                      <span className="text-white text-sm font-bold">✗</span>
                    </div>
                  </div>
                  <div className="ml-5 w-0 flex-1">
                    <dl>
                      <dt className="text-sm font-medium text-gray-500 truncate">
                        今日失败转账
                      </dt>
                      <dd className="text-lg font-medium text-gray-900">
                        {summary.todayFailedCount}笔
                      </dd>
                    </dl>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white overflow-hidden shadow rounded-lg">
              <div className="p-5">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center">
                      <span className="text-white text-sm font-bold">¥</span>
                    </div>
                  </div>
                  <div className="ml-5 w-0 flex-1">
                    <dl>
                      <dt className="text-sm font-medium text-gray-500 truncate">
                        今日转账总额
                      </dt>
                      <dd className="text-lg font-medium text-gray-900">
                        ¥{summary.todayTotalAmount.toFixed(2)}
                      </dd>
                    </dl>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white overflow-hidden shadow rounded-lg">
              <div className="p-5">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <div className="w-8 h-8 bg-yellow-500 rounded-full flex items-center justify-center">
                      <span className="text-white text-sm font-bold">⏱</span>
                    </div>
                  </div>
                  <div className="ml-5 w-0 flex-1">
                    <dl>
                      <dt className="text-sm font-medium text-gray-500 truncate">
                        处理中转账
                      </dt>
                      <dd className="text-lg font-medium text-gray-900">
                        {summary.processingCount}笔
                      </dd>
                    </dl>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  )
}
